import BigNumber from 'bignumber.js';
import { Address } from 'viem';

import { api, cacheTags, IConnectedActionParams } from 'modules/api';
import { LIQUID_STAKING_TOKEN_ADDRESS } from 'modules/api/const';
import { getStakeTokenBalance } from 'modules/api/methods/getStakeTokenBalance';
import { asAddress } from 'modules/api/utils/asAddress';
import { getWalletClient } from 'modules/api/walletClient';

interface IGetStakeTokenBalanceArgs extends IConnectedActionParams {
  poolAddress?: Address;
}

export const { useGetStakeTokenBalanceQuery } = api.injectEndpoints({
  endpoints: build => ({
    getStakeTokenBalance: build.query<
      BigNumber,
      IGetStakeTokenBalanceArgs | void
    >({
      queryFn: async params => {
        const { poolAddress = LIQUID_STAKING_TOKEN_ADDRESS } = params || {};

        const currentAccount = asAddress(getWalletClient()?.account?.address);

        const result = await getStakeTokenBalance(currentAccount, poolAddress);

        return { data: result };
      },
      providesTags: [cacheTags.account, cacheTags.liquidStaking],
    }),
  }),
});
